
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("bwe76", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $4f2298c40efbada1$export$2e2bcd8739ae039);

var $kUWZ2 = parcelRequire("kUWZ2");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $4jFaw = parcelRequire("4jFaw");
function $4f2298c40efbada1$export$2e2bcd8739ae039({ queries: { queryRef: queryRef } }) {
    const data = (0, $j4oe4.usePreloadedQuery)((0, $kUWZ2.default), queryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jFaw.DashboardsContent), {
        queryRef: data
    });
}

});
parcelRegister("kUWZ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8f6259107dd1a09$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<76cb6444f1372f8646d016b4de6cea5d>>
 * @relayHash 9a58486151638f4e45660f746394b248
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d

var $37Ewn = parcelRequire("37Ewn");
const $e8f6259107dd1a09$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v2 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v2 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "DashboardsContentViewQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v3 /*: any*/ 
                                },
                                v4 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "187971dfb7440b89eb5a98f67e766ec91b921dc8dd450612125a7211123e347d",
            "metadata": {},
            "name": "DashboardsContentViewQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e8f6259107dd1a09$var$node.hash = "2a6d30dd0ebce8d8b8a64e7710f0879f";
(0, $37Ewn.PreloadableQueryRegistry).set($e8f6259107dd1a09$var$node.params.id, $e8f6259107dd1a09$var$node);
var $e8f6259107dd1a09$export$2e2bcd8739ae039 = $e8f6259107dd1a09$var$node;

});

parcelRegister("4jFaw", function(module, exports) {
$parcel$export(module.exports, "DashboardsContent", () => $3d97f5e61ffd4199$export$439bb78193b2b442);

var $jGnwo = parcelRequire("jGnwo");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $85fS3 = parcelRequire("85fS3");
var $ih05Y = parcelRequire("ih05Y");
var $1ejND = parcelRequire("1ejND");
var $4REVJ = parcelRequire("4REVJ");

var $5SdQs = parcelRequire("5SdQs");

var $lRq8t = parcelRequire("lRq8t");

var $h4Bzb = parcelRequire("h4Bzb");

var $dpxw4 = parcelRequire("dpxw4");

var $hc6Nm = parcelRequire("hc6Nm");

var $i0tMD = parcelRequire("i0tMD");

var $h3HFC = parcelRequire("h3HFC");

var $3uQAw = parcelRequire("3uQAw");

var $cHtIB = parcelRequire("cHtIB");

var $jyIAe = parcelRequire("jyIAe");

var $ht7jn = parcelRequire("ht7jn");

var $2QH3X = parcelRequire("2QH3X");

var $lGy5z = parcelRequire("lGy5z");

var $4RWsk = parcelRequire("4RWsk");

var $9twek = parcelRequire("9twek");

var $6L63Q = parcelRequire("6L63Q");
const $3d97f5e61ffd4199$var$MAX_RECENT_PROJECTS = 5;
const $3d97f5e61ffd4199$var$MAX_FAVORITE_PROJECTS = 15;
const $3d97f5e61ffd4199$var$VIEW_ALL_STARRED_HREF = '/jira/your-work?starred';
function $3d97f5e61ffd4199$export$439bb78193b2b442({ queryRef: queryRef }) {
    const cloudId = (0, $cHtIB.useCloudId)();
    const { isSelectedPath: isSelectedPath } = (0, $dpxw4.useSidebarNav4)();
    const { getStableItems: getStableItems } = (0, $3uQAw.useStableItems)();
    // https://jplat.jira.atlassian.cloud/browse/BLU-2719
    // We intentionally request 15 starred and 20 recent dashboards.
    // Then, if all 10 starred dashboards were recently visited, we still show 5 recent dashboards as well.
    const [{ jira: { dashboardFavourites: dashboardFavourites, dashboardRecents: dashboardRecents } }, refetch] = (0, $j4oe4.useRefetchableFragment)((0, $jGnwo.default), queryRef);
    (0, $hc6Nm.useRefetchWhenIsSelected)({
        cloudId: cloudId,
        isSelectedPath: isSelectedPath,
        QUERY: $9twek.default,
        refetch: refetch,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS)
    });
    const refetchOnChange = (0, $eJOHy.useCallback)(({ onComplete: onComplete })=>{
        refetch({
            cloudId: cloudId
        }, {
            fetchPolicy: 'store-and-network',
            onComplete: onComplete
        });
    }, [
        cloudId,
        refetch
    ]);
    (0, $h3HFC.useSubscribeAndUpdateFavorites)({
        entityTypename: 'JiraDashboard',
        favouriteConnectionId: dashboardFavourites.__id,
        recentConnectionId: dashboardRecents.__id,
        refetch: refetchOnChange
    });
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const starred = formatMessage((0, $6L63Q.default).starred);
    const recent = formatMessage((0, $6L63Q.default).recent);
    const customerService = formatMessage((0, $6L63Q.default).customerService);
    const showNestedCustomerServiceAnalytics = (0, $ht7jn.useShowCustomerServiceAnalytics)();
    // Use dashboard-specific message when AVP flag is on (which is the only time this item is shown in dashboard context)
    const { formattedMessage: customerServiceOverviewLabel, icon: dashboardsIcon } = (0, $2QH3X.useFormattedMessageAndIcon)((0, $6L63Q.default).customerServiceOverview, (0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))));
    const favorites = (0, $eJOHy.useMemo)(()=>{
        const ids = dashboardFavourites.edges?.map((edge)=>edge?.node.id).filter(Boolean) ?? [];
        const list = dashboardFavourites.edges?.filter(Boolean).map((edge)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGy5z.DashboardMenuItem), {
                key: edge.node.dashboardId,
                queryRef: edge.node
            })) ?? [];
        return {
            idSet: new Set(ids),
            list: list.slice(0, $3d97f5e61ffd4199$var$MAX_FAVORITE_PROJECTS),
            hasItems: Boolean(list.length),
            hasNextPage: dashboardFavourites?.pageInfo?.hasNextPage || list.length > $3d97f5e61ffd4199$var$MAX_FAVORITE_PROJECTS
        };
    }, [
        dashboardFavourites
    ]);
    const recentItems = (0, $eJOHy.useMemo)(()=>{
        const nodes = dashboardRecents.edges?.filter(Boolean).filter((edge)=>edge.node.id && !favorites.idSet.has(edge.node.id)).map((edge)=>edge.node).slice(0, $3d97f5e61ffd4199$var$MAX_RECENT_PROJECTS) || [];
        const stableOrderedNodes = getStableItems({
            nodes: nodes,
            idKey: 'id'
        });
        const list = stableOrderedNodes.map((node)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lGy5z.DashboardMenuItem), {
                key: node.dashboardId,
                queryRef: node
            }));
        return {
            list: list,
            hasItems: Boolean(list.length)
        };
    }, [
        dashboardRecents.edges,
        favorites.idSet,
        getStableItems
    ]);
    if (!favorites.hasItems && !recentItems.hasItems && !showNestedCustomerServiceAnalytics) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4RWsk.DashboardsEmptyContent), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, favorites.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, starred), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, favorites.list))), favorites.hasNextPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: $3d97f5e61ffd4199$var$VIEW_ALL_STARRED_HREF,
        menuId: (0, $h4Bzb.MENU_ID_DASHBOARDS_VIEW_ALL_STARRED)
    }, formatMessage((0, $6L63Q.default).viewAllStarred))), recentItems.hasItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, recent), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, recentItems.list))), showNestedCustomerServiceAnalytics && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ih05Y.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1ejND.MenuSection), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4REVJ.MenuSectionHeading), null, customerService), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: (0, $jyIAe.CUSTOMER_SERVICE_ANALYTICS_HREF),
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: dashboardsIcon
    }, customerServiceOverviewLabel)))));
}

});
parcelRegister("jGnwo", function(module, exports) {
$parcel$export(module.exports, "default", () => $407e60580854a384$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<11ee00a8f92b503876d9bf6eeff66af8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $9twek = parcelRequire("9twek");
const $407e60580854a384$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = {
        "kind": "ScalarField",
        "name": "dashboardId"
    }, v3 = {
        "kind": "FragmentSpread",
        "name": "DashboardMenuItem"
    }, v4 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "cloudId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "currentURL"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "refetch": {
                "fragmentPathInResult": [],
                "operation": (0, $9twek.default)
            }
        },
        "name": "DashboardsContent",
        "selections": [
            {
                "kind": "RequiredField",
                "field": {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardFavourites",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                            "sort": {
                                                "order": "DESC"
                                            },
                                            "type": "DASHBOARD"
                                        }
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 15
                                    }
                                ],
                                "concreteType": "JiraFavouriteConnection",
                                "kind": "LinkedField",
                                "name": "favourites",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "PageInfo",
                                        "kind": "LinkedField",
                                        "name": "pageInfo",
                                        "plural": false,
                                        "selections": [
                                            {
                                                "kind": "ScalarField",
                                                "name": "hasNextPage"
                                            }
                                        ]
                                    },
                                    {
                                        "concreteType": "JiraFavouriteEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardFavourites.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardFavourites.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardFavourites"
                        },
                        {
                            "kind": "RequiredField",
                            "field": {
                                "alias": "dashboardRecents",
                                "args": [
                                    v0 /*: any*/ ,
                                    {
                                        "kind": "Variable",
                                        "name": "currentURL",
                                        "variableName": "currentURL"
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 20
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "types",
                                        "value": [
                                            "DASHBOARD"
                                        ]
                                    }
                                ],
                                "concreteType": "JiraSearchableEntityConnection",
                                "kind": "LinkedField",
                                "name": "recentItems",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraSearchableEntityEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "RequiredField",
                                                "field": {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v1 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "jira.dashboardRecents.edges.node.id"
                                                                },
                                                                v2 /*: any*/ ,
                                                                v3 /*: any*/ 
                                                            ],
                                                            "type": "JiraDashboard"
                                                        }
                                                    ]
                                                },
                                                "action": "THROW",
                                                "path": "jira.dashboardRecents.edges.node"
                                            }
                                        ]
                                    },
                                    v4 /*: any*/ 
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.dashboardRecents"
                        }
                    ]
                },
                "action": "THROW",
                "path": "jira"
            }
        ],
        "type": "Query"
    };
}();
$407e60580854a384$var$node.hash = "2efc6b73165a1bbb92f1953043700da4";
var $407e60580854a384$export$2e2bcd8739ae039 = $407e60580854a384$var$node;

});
parcelRegister("9twek", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae7cd955d2988a82$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<be6f5993018a343b4acafe0061e2e04e>>
 * @relayHash abf151795028f3770a9300523a04af00
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31
const $ae7cd955d2988a82$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "currentURL"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "currentURL",
        "variableName": "currentURL"
    }, v2 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = [
        {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "__typename"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "dashboardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "JiraFavouriteValue",
                            "kind": "LinkedField",
                            "name": "favouriteValue",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isFavourite"
                                },
                                v3 /*: any*/ 
                            ]
                        }
                    ],
                    "type": "JiraDashboard"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        v3 /*: any*/ 
                    ],
                    "type": "Node",
                    "abstractKey": "__isNode"
                }
            ]
        }
    ], v5 = {
        "kind": "ClientExtension",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__id"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "DashboardsContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "Nav4DashboardsContentQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "dashboardFavourites",
                            "args": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                        "sort": {
                                            "order": "DESC"
                                        },
                                        "type": "DASHBOARD"
                                    }
                                },
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 15
                                }
                            ],
                            "concreteType": "JiraFavouriteConnection",
                            "kind": "LinkedField",
                            "name": "favourites",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraFavouriteEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        },
                        {
                            "alias": "dashboardRecents",
                            "args": [
                                v2 /*: any*/ ,
                                v1 /*: any*/ ,
                                {
                                    "kind": "Literal",
                                    "name": "first",
                                    "value": 20
                                },
                                {
                                    "kind": "Literal",
                                    "name": "types",
                                    "value": [
                                        "DASHBOARD"
                                    ]
                                }
                            ],
                            "concreteType": "JiraSearchableEntityConnection",
                            "kind": "LinkedField",
                            "name": "recentItems",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraSearchableEntityEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": v4 /*: any*/ 
                                },
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "ae80ab59ee2189cebc2881d3c421bf61d0f5f6840817cb3dddfaff62c6677a31",
            "metadata": {},
            "name": "Nav4DashboardsContentQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ae7cd955d2988a82$var$node.hash = "2efc6b73165a1bbb92f1953043700da4";
var $ae7cd955d2988a82$export$2e2bcd8739ae039 = $ae7cd955d2988a82$var$node;

});


parcelRegister("jyIAe", function(module, exports) {
$parcel$export(module.exports, "CUSTOMER_SERVICE_ANALYTICS_HREF", () => $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3);

var $eJOHy = parcelRequire("eJOHy");

var $jUgeq = parcelRequire("jUgeq");

var $h4Bzb = parcelRequire("h4Bzb");

var $8IuE5 = parcelRequire("8IuE5");

var $i0tMD = parcelRequire("i0tMD");

var $eL2Ux = parcelRequire("eL2Ux");

var $59lfa = parcelRequire("59lfa");

var $8z6Yy = parcelRequire("8z6Yy");
const $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3 = '/jira/helpcenter/analytics';
const $ceb5d334a4e24ed4$var$MenuItems = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUgeq.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $59lfa.HideL1MenuItemSection), {
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        hasSeparator: false
    }));
const $ceb5d334a4e24ed4$export$d4508bff4cbbd271 = ()=>{
    const { formattedMessage: formattedMessage, icon: icon } = (0, $eL2Ux.useConfigurableMessageAndIconMap)((0, $8IuE5.L1_MENU_ID).CUSTOMER_SERVICE_ANALYTICS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        testId: "navigation-apps-sidebar-nav4-sidebars-content-customer-service-analytics.ui.sidenav-customer-service",
        href: $ceb5d334a4e24ed4$export$df8bbcec1e54e3c3,
        menuId: (0, $h4Bzb.MENU_ID_CUSTOMER_SERVICE_ANALYTICS),
        elemBefore: icon,
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
            MenuItems: $ceb5d334a4e24ed4$var$MenuItems
        })
    }, formattedMessage);
};

});

parcelRegister("ht7jn", function(module, exports) {
$parcel$export(module.exports, "useShowCustomerServiceAnalytics", () => $594909db36a8e283$export$4aaa66e80d627346);

var $cblKs = parcelRequire("cblKs");

var $kAwwe = parcelRequire("kAwwe");

var $1BZ8a = parcelRequire("1BZ8a");
const $594909db36a8e283$export$4aaa66e80d627346 = ()=>{
    const isAdmin = (0, $kAwwe.useIsAdmin)();
    const { customerService: customerService } = (0, $1BZ8a.useAppEditions)();
    if (customerService === (0, $cblKs.UNLICENSED)) return false;
    return isAdmin;
};

});

parcelRegister("lGy5z", function(module, exports) {
$parcel$export(module.exports, "DashboardMenuItem", () => $3d23a17c8a714051$export$5c7baf31dfb5503f);

var $iCTNh = parcelRequire("iCTNh");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $5SdQs = parcelRequire("5SdQs");

var $a9aec = parcelRequire("a9aec");

var $h4Bzb = parcelRequire("h4Bzb");

var $i0tMD = parcelRequire("i0tMD");

var $kJJos = parcelRequire("kJJos");

var $6N5hT = parcelRequire("6N5hT");
function $3d23a17c8a714051$export$5c7baf31dfb5503f({ queryRef: queryRef }) {
    const data = (0, $j4oe4.useFragment)((0, $iCTNh.default), queryRef);
    const { fireUIAnalyticForDashboardItems: fireUIAnalyticForDashboardItems } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    if (!data) return null;
    const dashboardUrl = `/jira/dashboards/${data.dashboardId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $i0tMD.Nav4MenuLinkItem), {
        href: dashboardUrl,
        menuId: (0, $h4Bzb.ENTITY_ID).DASHBOARD(String(data.dashboardId)),
        actionsOnHover: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6N5hT.DashboardPopupMenu), {
            dashboardData: data
        }),
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5SdQs))), {
            label: "",
            color: "currentColor"
        }),
        onClick: ()=>{
            fireUIAnalyticForDashboardItems({
                itemId: String(data.dashboardId),
                section: data?.favouriteValue?.isFavourite ? (0, $a9aec.SECTION_ITEM_STARRED) : (0, $a9aec.SECTION_ITEM_RECENT)
            });
        }
    }, data.title);
}

});
parcelRegister("iCTNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d6922cff6601ab7$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<4b252365ea6f4033de11ad3ac85b26fb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4d6922cff6601ab7$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardMenuItem",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "title"
            },
            "action": "THROW",
            "path": "title"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "DashboardPopupMenu"
        }
    ],
    "type": "JiraDashboard"
};
$4d6922cff6601ab7$var$node.hash = "e30b21c7949d8052bd6833da91711e25";
var $4d6922cff6601ab7$export$2e2bcd8739ae039 = $4d6922cff6601ab7$var$node;

});

parcelRegister("6N5hT", function(module, exports) {
$parcel$export(module.exports, "DashboardPopupMenu", () => $7163dd746739f084$export$4fdb1267041f7bae);

var $20qdF = parcelRequire("20qdF");

var $eJOHy = parcelRequire("eJOHy");

var $j4oe4 = parcelRequire("j4oe4");

var $2sLVw = parcelRequire("2sLVw");

var $85fS3 = parcelRequire("85fS3");


var $6Hwhu = parcelRequire("6Hwhu");

var $8z6Yy = parcelRequire("8z6Yy");


var $kJJos = parcelRequire("kJJos");
const $7163dd746739f084$export$4fdb1267041f7bae = ({ dashboardData: dashboardData })=>{
    const data = (0, $j4oe4.useFragment)((0, $20qdF.default), dashboardData);
    const { fireUIAnalyticForFixButton: fireUIAnalyticForFixButton, fireUIAnalyticForFavouriteToggle: fireUIAnalyticForFavouriteToggle } = (0, $eJOHy.useContext)((0, $kJJos.AnalyticContext));
    const handleNavMenuOpen = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFixButton({
            itemId: (0, $e6bca68b75395543$export$f06dfcec5ff912e)
        });
    }, [
        fireUIAnalyticForFixButton
    ]);
    const isFavourite = Boolean(data?.favouriteValue?.isFavourite);
    const handleFavouriteClick = (0, $eJOHy.useCallback)(()=>{
        fireUIAnalyticForFavouriteToggle({
            starType: isFavourite ? (0, $63bde0b156ffab77$export$5fe513938f2c4081) : (0, $63bde0b156ffab77$export$54408be40394d82a),
            parentItemId: String(data.dashboardId)
        });
    }, [
        data.dashboardId,
        fireUIAnalyticForFavouriteToggle,
        isFavourite
    ]);
    const MenuItems = (0, $eJOHy.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $85fS3.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6Hwhu.FavoriteToggleButton), {
            entityId: data.id,
            defaultIsStarred: isFavourite,
            entityTypeName: "JiraDashboard",
            onClick: handleFavouriteClick
        })), [
        data.id,
        handleFavouriteClick,
        isFavourite
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        gap: "space.050",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8z6Yy.MoreNavMenuButton), {
        onOpen: handleNavMenuOpen,
        MenuItems: MenuItems
    }));
};

});
parcelRegister("20qdF", function(module, exports) {
$parcel$export(module.exports, "default", () => $a140de966cecc229$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<36e17dcd5ce3ff2971120c2bb95528a0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $a140de966cecc229$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "DashboardPopupMenu",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "id"
            },
            "action": "THROW",
            "path": "id"
        },
        {
            "kind": "RequiredField",
            "field": {
                "kind": "ScalarField",
                "name": "dashboardId"
            },
            "action": "THROW",
            "path": "dashboardId"
        },
        {
            "concreteType": "JiraFavouriteValue",
            "kind": "LinkedField",
            "name": "favouriteValue",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isFavourite"
                }
            ]
        }
    ],
    "type": "JiraDashboard"
};
$a140de966cecc229$var$node.hash = "a386558bb17b8fafc916eb203a4d28ee";
var $a140de966cecc229$export$2e2bcd8739ae039 = $a140de966cecc229$var$node;

});

const $63bde0b156ffab77$export$54408be40394d82a = 'star';
const $63bde0b156ffab77$export$5fe513938f2c4081 = 'unstar';

const $e6bca68b75395543$export$b8b9d90f9e5bd72b = 'jiraNavigationAppsSidebarNav4Dashboards';
const $e6bca68b75395543$export$d57b6b390e78d90f = 'jira-cosmos';
const $e6bca68b75395543$export$65b778215f917c60 = 'viewAllDashboards';
const $e6bca68b75395543$export$7be02fe416808d26 = 'createDashboard';
const $e6bca68b75395543$export$f06dfcec5ff912e = 'meatballDropdown';



parcelRegister("4RWsk", function(module, exports) {
$parcel$export(module.exports, "DashboardsEmptyContent", () => $46bad5fbeee0f043$export$54678b9782e1c19b);

var $eJOHy = parcelRequire("eJOHy");

var $3cMgR = parcelRequire("3cMgR");

var $lRq8t = parcelRequire("lRq8t");

var $eLY13 = parcelRequire("eLY13");

var $a9Cnb = parcelRequire("a9Cnb");
function $46bad5fbeee0f043$export$54678b9782e1c19b() {
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eLY13.EmptyContentMenuItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $a9Cnb.default).emptyDashboardsMessage)));
}

});
parcelRegister("a9Cnb", function(module, exports) {
$parcel$export(module.exports, "default", () => $19f3ace543b45940$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $19f3ace543b45940$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    emptyDashboardsMessage: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.empty-content.empty-dashboards-message",
        "defaultMessage": "Once you visit or create dashboards, they\u2019ll show up here."
    }
});

});


parcelRegister("6L63Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ea40c9e1763ef8f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $1ea40c9e1763ef8f$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    recent: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.recent",
        "defaultMessage": "Recent"
    },
    starred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.starred",
        "defaultMessage": "Starred"
    },
    viewAllStarred: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.view-all-starred",
        "defaultMessage": "View all starred"
    },
    customerService: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.customer-service",
        "defaultMessage": "Customer service"
    },
    customerServiceOverview: {
        "id": "navigation-apps-sidebar-nav4-sidebars-content-dashboards.common.content.customer-service-overview",
        "defaultMessage": "Customer service overview"
    }
});

});




//# sourceMappingURL=nav4-dashboards-content-entry-point.9b2bd652.js.map
